import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { Form, Input } from "antd";
import CustomModal from "../../../components/Common/CustomModal";

interface AddEditExpenseCategoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  categoryData: any;
  onSave: (data: any) => void;
}

const AddEditExpenseCategoryModal = ({
  isOpen,
  onClose,
  categoryData,
  onSave,
}: AddEditExpenseCategoryModalProps) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (categoryData) {
      form.setFieldsValue(categoryData);
    } else {
      form.resetFields();
    }
  }, [categoryData]);

  const handleSave = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();
      await onSave(values);
      onClose();
      form.resetFields();
    } catch (error) {
      // Handle error
    } finally {
      setLoading(false);
    }
  };

  return (
    <CustomModal
      title={
        categoryData?.id
          ? t("edit_expense_category")
          : t("add_expense_category")
      }
      isOpen={isOpen}
      onClose={onClose}
      onSave={handleSave}
      loading={loading}
      saveText={categoryData?.id ? t("save") : t("add")}
    >
      <Form
        form={form}
        layout="vertical"
        // initialValues={{
        //   name: categoryData?.name || "",
        //   description: categoryData?.description || "",
        // }}
      >
        <Form.Item
          label={t("name")}
          name="name"
          rules={[{ required: true, message: t("please_enter_name") }]}
        >
          <Input placeholder={t("enter_category_name")} />
        </Form.Item>
        <Form.Item label={t("description")} name="description">
          <Input.TextArea placeholder={t("description")} />
        </Form.Item>
      </Form>
    </CustomModal>
  );
};

export default AddEditExpenseCategoryModal;
